<template>
<main class="about" :class="loaded ? 'loaded' : loaded" v-if="about && Object.keys(about).length">
  <section class="padded page-header">
    <h1 class="discret">{{about[currentLang].title}}</h1>
    <p class="catch-line" v-html="setDescription(about[currentLang].description)"></p>
  </section>
  <scroll-view>
    <template slot-scope="visibility">
      <component :is="component" v-for="component in aboutComponents"
        :currentLang="currentLang"
        :displayLogo="true"
        :key="component" 
        :about="about" 
        :isLandingMounted="isLanding"
        :visible="visibility[component]" 
        :site="site"/>
    </template>
  </scroll-view>
</main>
</template>

<script>
  
  const Partners = () => import( /* webpackChunkName: "Partners" */ '@/modules/Partners.vue');
  const Services = () => import( /* webpackChunkName: "Services" */ '@/modules/Services.vue');
  const Team = () => import( /* webpackChunkName: "Team" */ '@/modules/Team.vue');
  const ContactFooter = () => import( /* webpackChunkName: "ContactFooter" */ '@/snippets/ContactFooter.vue');

import { $scrollview } from 'vue-scrollview'
import { mapState } from 'vuex'
import loaderHandler  from '@/mixins/loaderHandler.js'

  export default {
    props:['currentLang'],
    name: 'About',
    components: {
      Partners,
      Services,
      Team,
      ContactFooter
    },
    mixins: [loaderHandler],
    metaInfo() {
      return {
        title: this.about.title,
         meta: [
          { name: 'description', content: null, },
          {
            property: 'og:description',
            content: null,
          },
          {
            property: 'og:url',
            content: this.site.url+this.$route.fullPath,
          },
        ]
      }
    },
    data(){
      return {
        updateNav: true,
        aboutComponents: ['Partners', 'Services', 'Team', 'ContactFooter'],
        scroll: $scrollview,
        isLanding: true
      }
    },
    computed: mapState(['site', 'about']),
    methods: {
      emitToApp(){
        this.$emit('mountedPage', {isBgLight : true});
      },
      setDescription(desc){
        this.$metaInfo.meta[0].description = this.$metaInfo.meta[1].description = desc;
        return desc;
      }
    },
    created() {
      this.$store.dispatch('loadAbout');
    },
    mounted(){
      this.emitToApp();
      this.displayComponent(200);
    },
  }
</script>

<style lang="scss">
  main{
     min-height: 100vh;
     .page-header{
        opacity:0;
        @include transform(translate(0,10%));
        @include transition(opacity .5s ease, transform .3s ease);
     }
     &.loaded{
        .page-header{
          opacity:1;
          @include transform(translate(0,0));
        }
     }
  }
</style>
